// src/components/Login.tsx
import React from "react";

const Login: React.FC = () => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center p-4">
      <h2 className="mb-4">Sign in with Google</h2>
      <a href="http://13.202.240.253:5000/api/auth/google">
        <button className="btn btn-primary">Login with Google</button>
      </a>
    </div>
  );
};

export default Login;
